import { useEffect, useRef, useState } from "react";

const Timer = ({ initialSeconds, onComplete }) => {
    const [timeLeft, setTimeLeft] = useState(initialSeconds);
    const initialTimeRef = useRef(initialSeconds);
    const intervalRef = useRef(null); // برای نگهداری interval

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(intervalRef.current);
                    if (onComplete) {
                        onComplete(); // صدا زدن onComplete وقتی تایمر تموم شد
                    }
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(intervalRef.current);
    }, [onComplete]); // onComplete رو به dependency اضافه کن اگر تغییر کنه

    const formatTime = (seconds) => {
        const clampedSeconds = Math.max(seconds, 0); // جلوگیری از منفی شدن
        const hours = Math.floor(clampedSeconds / 3600);
        const mins = Math.floor((clampedSeconds % 3600) / 60);
        const secs = clampedSeconds % 60;
        return `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    };

    const getTimerColor = () => {
        if (timeLeft < 300) return "text-red-600";
        if (timeLeft < 600) return "text-orange-600";
        return "text-green-600";
    };

    const totalTime = initialTimeRef.current || 1;
    const progress = Math.max((timeLeft / totalTime) * 100, 0);

    return (
        <div className="rest-orders-timer">
            <span className="rest-orders-timer__label">
                زمان باقی‌مانده
            </span>
            <span className={`rest-orders-timer__value ${getTimerColor()}`}>
                {formatTime(timeLeft)}
            </span>
            <div className="rest-orders-timer__track">
                <div
                    className={`rest-orders-timer__bar transition-all duration-1000 ${
                        timeLeft < totalTime * 0.25
                            ? "bg-red-500"
                            : timeLeft < totalTime * 0.5
                                ? "bg-orange-500"
                                : "bg-green-500"
                    }`}
                    style={{width: `${progress}%`}}
                ></div>
            </div>
        </div>
    );
};

export default Timer;